// eslint-disable-next-line import/prefer-default-export
export const ages = [
  { name: '22-30', key: 1 },
  { name: '31-40', key: 2 },
  { name: '41-50', key: 3 },
  { name: '51-60', key: 4 },
  { name: '61-70', key: 5 },
  { name: '70+', key: 6 },
];
